import { render, staticRenderFns } from "./StakeUI.vue?vue&type=template&id=3c7d2292&"
import script from "./StakeUI.vue?vue&type=script&setup=true&lang=js&"
export * from "./StakeUI.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports